<h5 id="title">Catégories</h5>
<ng-container *ngFor="let category of (categories$ | async); let last = last">
  <a *ngIf="!last" [queryParams]="{ category: category.id}" [routerLink]="'/products'">{{category.name}}, </a>
  <a *ngIf="last" [queryParams]="{ category: category.id}" [routerLink]="'/products'">{{category.name}}</a>
</ng-container>
